var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/logo/Logo.tsx",
  _this = this;
import React, { useContext } from 'react';
import { IconLogoGoldie } from '@wds/icons';
import { defineMessages, t } from '@sm/intl';
import { generateMetricsAttribute } from '@sm/metrics';
import { useHeaderTheme } from '../../theme';
import useStyles from './useStyles';
import HeaderContext from '../../HeaderContext';
export var COPY = defineMessages({
  LOGO: {
    id: 'Logo.logoLabel',
    defaultMessage: 'Brand logo',
    description: '[Type: Label][Vis.: high] - This is the brand logo on the header.'
  }
});
export var Logo = function Logo(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? t(COPY.LOGO) : _ref$label,
    link = _ref.link;
  var theme = useHeaderTheme();
  var classes = useStyles({
    theme: theme
  });
  var _useContext = useContext(HeaderContext),
    pageURL = _useContext.pageURL,
    pageName = _useContext.pageName;
  return /*#__PURE__*/React.createElement("span", {
    className: classes.logo,
    "aria-label": "logo",
    "data-sm-metrics": generateMetricsAttribute({
      data: {
        url: pageURL,
        pageName: pageName,
        amplitudeEvent: 'header clicked navigation',
        navItem: 'logo'
      }
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: link,
    className: classes.logo,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(IconLogoGoldie, {
    title: label,
    size: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 9
    }
  })));
};
//# sourceMappingURL=Logo.js.map